export enum ReportType {
  WEEKLY_CONTRACT_COUNT = '1',
  GENERAL_STATISTICS = '2',
  REQUIRED_ACTIONS = '3',
  CLIENT_PERFORMANCE = '4',
  STATISTICS_PER_COST_CENTER = '5',
  FTE_CHECK = '6',
  DOCUMENT_FOLLOW_UP = '7',
}
